<div
  class="multi-price"
  [ngClass]="{ 'multi-price--active': params.data.MapIsActive }"
>
  <span class="multi-price_name">{{ price.name }}: </span>
  <span class="multi-price_price">{{ price.price | currency }}</span>

  <span *ngIf="price.isActive !== undefined" class="multi-price_icon">
    <i class="fal fa-bolt" *ngIf=""></i>
    <span *ngIf="!price.isActive">M</span>
  </span>
</div>
